import styled from 'styled-components';
import { showForSR } from '_utils/styles';

export default styled.span`
  ${showForSR}
`;
